import { DrawerCloseButton } from '@chakra-ui/react'

export default DrawerCloseButton
